import { default as app, collapsibleHeaderClickEvent, onWindowResize, resetSelectionColumn, ToggleYellowToGreen, ToggleGreenToYellow, IsUndefinedOrNull } from '@legacy/App';

app.factory('UserFactory', ['$http', 'settings', function ($http, settings) {
    return {
        getNewUser: function () {
            return $http.get(settings.ApiURL + settings.UserURL + "/newUser");
        },
        getRoles: function (isSysAdmin) {
            return $http.get(settings.ApiURL + settings.UserURL + "/role/"+ isSysAdmin);
        },
        getFleets: function () {
            return $http.get(settings.ApiURL + settings.FleetURL);
        },
        getUserDetails: function (id) {
            return $http.get(settings.ApiURL + settings.UserURL + "/" + id);
        },
        saveUser: function (User) {
            return $http.put(settings.ApiURL + settings.UserURL, User);
        },
        checkUser: function (userName, companyId) {
            return $http.get(settings.ApiURL + settings.UserURL + "/" + userName + "/" + companyId);
        },
        deleteUser: function (id) {
            return $http.delete(settings.ApiURL + settings.UserURL + "/" + id);
        },
        getUserList: function (accessToken) {
            return $http.get(settings.ApiURL + settings.UserURL);
        }
    };
}]);

app.controller('UserController', ['$q', '$scope', 'UserFactory', '$rootScope', 'settings', 'masterFactory', 'CompanyFactory',
    function ($q, $scope, UserFactory, $rootScope, settings, masterFactory, CompanyFactory) {
        $rootScope.pageTitle = "User";
        $scope.companyDropdown = [];
        $scope.Roles = [];
        $scope.Fleets = [];
        $scope.Users = [];
        $scope.User = {};
        $scope.newUser = {};
        $scope.error = "";
        $scope.modelState = [];
        $scope.isFormVisible = false;
        $scope.isNewUser = false;
        $scope.pageSize = 20;

        // Initialization - this runs on load
        var init = function (pageIndex) {
            masterFactory.verifyAuthentication();

            $q.all([
                UserFactory.getRoles($rootScope.user.isSysAdmin).success(function (data) {
                    $scope.Roles = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                UserFactory.getFleets().success(function (data) {
                    $scope.Fleets = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                CompanyFactory.getCompanyDropDown(0).success(function (data) {
                    $scope.companyDropdown = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                UserFactory.getUserList($rootScope.accessToken).success(function (data) {
                    $scope.Users = data;
                    $scope.refreshGrid(0, null);
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }),
                UserFactory.getNewUser().success(function (data) {
                    $scope.newUser = data;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                })
            ]).then(function () {
            });
        };

        var getUser = function (id) {
            UserFactory.getUserDetails(id).success(function (data) {
                $scope.User = data;
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            });
        };

        init(0);

        // Grid renderers
        $scope.refreshGrid = function (PageIndex, Key) {
            $('#gridUser').dxDataGrid({
                dataSource: {
                    store: {
                        data: $scope.Users,
                        type: 'array',
                        key: 'Id'
                    }
                },
                noDataText: "No Users Found",
                showColumnLines: true,
                showRowLines: false,
                showBorders: true,
                rowAlternationEnabled: false,
                contentReadyAction: grdReadyAction,
                selection: { mode: 'single' },
                paging: {
                    pageSize: $scope.pageSize,
                    pageIndex: PageIndex
                },
                scrolling: {
                    mode: 'standard'
                },
                pager: {
                    showPageSizeSelector: true,
                    allowedPageSizes: [10, 20, 30]
                },
                filterRow: {
                    visible: true
                },
                groupPanel: {
                    visible: false,
                },
                columns: [
                    { dataField: 'Id', visible: false, dataType: 'number' },
                    {
                        caption: 'User name', dataField: 'UserName', cssClass: 'UserName',dataType: 'string', alignment: 'center',
                        cellTemplate: function (container, options) {
                            $('<span />')
                           .text(options.data.UserName)
                           .appendTo(container);
                            container.addClass('grid-cell-align-left');
                        }
                    },
                    {
                        caption: 'Company', dataField: 'CompanyName', cssClass: 'CompanyName', dataType: 'string', alignment: 'center',
                        cellTemplate: function (container, options) {
                            $('<span />')
                           .text(options.data.CompanyName)
                           .appendTo(container);
                            container.addClass('grid-cell-align-left');
                        }
                    },
                    { caption: 'Fleet', dataField: 'Fleet', cssClass: 'Fleet', dataType: 'string', alignment: 'center' }
                ],
                selectionChanged: function (selectedRowsInfo) {
                    if (selectedRowsInfo.selectedRowsData[0] != null) {
                        getUser(selectedRowsInfo.selectedRowsData[0].Id);
                    }
                    else $scope.User = angular.copy($scope.newUser);

                    $scope.isFormVisible = true;
                    $scope.isNewUser = false;
                    ToggleYellowToGreen();
                    $rootScope.pageTitle = "User";
                }

            });

            if (Key != null && Key > 0) {
                var dataGrid = $('#gridUser').dxDataGrid('instance');
                (dataGrid as unknown as FacnmDx).selectRows([Key]);
            }
        };

        // Button click functions and submit form function
        $scope.addNewEntity = function () {
            $rootScope.pageTitle = "New User";
            $scope.isFormVisible = true;
            $scope.isNewUser = true;
            $scope.User = angular.copy($scope.newUser);
            ToggleGreenToYellow();
        };

        $scope.cancelForm = function () {
            var dataGrid = $('#gridUser').dxDataGrid('instance');
            dataGrid.clearSelection();
            $scope.isFormVisible = false;
            $scope.userForm.$submitted = false;
            $scope.closeModelStateErrors();
            $scope.closeAlert();
        };

        $scope.reset = function (type) {
            if (type == 'update') { // get db User and set to scope.User.
                getUser($scope.User.Id);
            }
            else {
                angular.copy($scope.newUser, $scope.User);
            }
            $scope.userForm.$setPristine();
            $scope.userForm.$submitted = false;
            $scope.closeModelStateErrors();
            $scope.closeAlert();
            $scope.notify.add({ type: 'success', title: 'Success!', body: 'User details were reset' });
        };

        $scope.submitForm = function () {
            if ($scope.userForm.$valid) {
                $scope.saveUser();                
            } 
        };

        $scope.saveUser = function () {
            var pageindex, id;
            $scope.closeModelStateErrors();
            $scope.closeAlert();
            UserFactory.saveUser($scope.User).success(function (UserId) {
                UserFactory.getUserList($rootScope.accessToken).success(function (data) {
                    var dataGrid = $('#gridUser').dxDataGrid('instance');
                    $scope.pageSize = dataGrid.pageSize();
                    pageindex = dataGrid.pageIndex();
                    $scope.Users = data;
                    if ($scope.User.Id > 0) {
                        $scope.refreshGrid(pageindex, $scope.User.Id)
                    }
                    else {
                        $scope.cancelForm();
                        $scope.refreshGrid(pageindex, null);
                    }
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                    if ($scope.User.Id > 0) {
                        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated User successfully' });
                    }
                    else {
                        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Created User successfully' });
                    }
                });
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            });
        };

        $scope.IsUniqueUserName = function () {
            if($scope.User.UserName != null && $scope.User.CompanyId != null) {
                UserFactory.checkUser($scope.User.UserName, $scope.User.CompanyId).success(function (data) {
                    if (data == true) $scope.error = "A user with User Name: " + $scope.User.UserName + " already exists for selected Company";
                    else $scope.error = null;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                });
            }
        };

        // Helping functions and events
        $(window).resize(function () {
            onWindowResize('#gridUser', settings.GridMarginHeight);
        });

        function grdReadyAction(e) {
            onWindowResize('#gridUser', settings.GridMarginHeight);
        };

        collapsibleHeaderClickEvent($scope);

        $scope.closeAlert = function () {
            $scope.error = null;
        };

        $scope.closeModelStateErrors = function () {
            $scope.modelState = [];
        };

        $scope.clickHalfDiv = function (control) {
            masterFactory.setFocus(control);
        };
}]);